import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataEnum,
  ODataInteger,
  ODataDateTime,
  ODataDecimal,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export default function getTransactionsHeaders(enums) {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "components.inmemorydependants.effective_date",
      type: new ODataDate("EffectiveDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.type",
      type: new ODataEnum("Type", {
        getString: (item) => {
          return i18n.t("enums." + item.Type);
        },
        dropdownItems: enums.Type,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.amount",
      type: new ODataDecimal("Amount", {
        getString: (item, type) => {
          let value = item.Amount;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          if (
            item.Type === "Forfeit" ||
            item.Type === "Deduction" ||
            item.Type === "Reserved"
          ) {
            value = -Math.abs(value);
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.member_transactions.Balance Year",
      type: new ODataInteger("HSACredit/Year"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.reason",
      type: new ODataEnum("Activity", {
        getString: (item) => {
          return i18n.t("enums." + item.Activity);
        },
        dropdownItems: enums.Activity,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.member_transactions.Update reason",
      type: new ODataString("Reason", {
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      visible: true,
      sortable: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("User"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("UserType"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.trigger",
      type: new ODataString("ClaimSubmission/Identifier", {
        getString: (item) => {
          if (
            item.User !== null &&
            item.User !== undefined &&
            item.UserType !== null &&
            item.UserType !== undefined
          ) {
            return `${item.UserType} (${item.User})`;
          }
          return item.ClaimSubmission.Identifier;
        },
      }),
      sortable: false,
      visible: true,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
}
